import { useRef } from 'react';
import { Whisper, Button } from 'rsuite';
import { icons } from '@shared/static/icons';
import BalancesTableMobileMenu from '@widgets/balance/BalancesTableMobileMenu';
import ReferralsTableMobileMenu from '@widgets/referrals/ReferralsTableMobileMenu';
import { TeamTableMobileMenu, EditTeamMenu } from '@widgets/teams/menu';

const MENU_COMPONENTS = {
  teams: TeamTableMobileMenu,
  teamId: EditTeamMenu,
  balances: BalancesTableMobileMenu,
  referrals: ReferralsTableMobileMenu,
  // TODO: обновить меню транзакций, сейчас это копия меню баланса
  transactions: BalancesTableMobileMenu,
};

export default function TableMenuBtn({ data, menu }) {
  const ref = useRef();
  const MenuComponent = MENU_COMPONENTS[menu];

  function close() {
    ref.current.close();
  }

  function handleClick(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  return (
    <Whisper
      placement="auto"
      controlId="control-id-with-dropdown"
      trigger="click"
      ref={ref}
      speaker={<MenuComponent close={close} data={data} />}
    >
      <Button
        appearance="secondary"
        className="theme-btn theme-btn--icon"
        onClick={handleClick}
      >
        {icons.more}
      </Button>
    </Whisper>
  );
}
